import { CompanyExcel } from "../../domain/entities/CompanyExcel"

export class CompanyExcelModel {
	id: number
	file_date: string
	records_count: number
	total_amount: number
	microsite_id: number
	microsite_name: string
	original_filename: string
	status: string
	processed_by_user_id: number
	processed_by_user_name: string
	error_message?: string
	created_at: string

	constructor(data: any) {
		this.id = data.id
		this.file_date = data.file_date
		this.records_count = data.records_count
		this.total_amount = data.total_amount
		this.microsite_id = data.microsite_id
		this.microsite_name = data.microsite_name
		this.original_filename = data.original_filename
		this.status = data.status
		this.processed_by_user_id = data.processed_by_user_id
		this.processed_by_user_name = data.processed_by_user_name
		this.error_message = data.error_message
		this.created_at = data.created_at
	}

	toDomain(): CompanyExcel {
		return {
			id: this.id,
			fileDate: this.file_date,
			recordsCount: this.records_count,
			totalAmount: this.total_amount,
			micrositeId: this.microsite_id,
			micrositeName: this.microsite_name,
			originalFilename: this.original_filename,
			status: this.status,
			processedByUserId: this.processed_by_user_id,
			processedByUserName: this.processed_by_user_name,
			errorMessage: this.error_message,
			createdAt: this.created_at
		}
	}

	static fromDomain(companyExcel: CompanyExcel): CompanyExcelModel {
		return new CompanyExcelModel({
			id: companyExcel.id,
			file_date: companyExcel.fileDate,
			records_count: companyExcel.recordsCount,
			total_amount: companyExcel.totalAmount,
			microsite_id: companyExcel.micrositeId,
			microsite_name: companyExcel.micrositeName,
			original_filename: companyExcel.originalFilename,
			status: companyExcel.status,
			processed_by_user_id: companyExcel.processedByUserId,
			processed_by_user_name: companyExcel.processedByUserName,
			error_message: companyExcel.errorMessage,
			created_at: companyExcel.createdAt
		})
	}
}
